module.exports = __webpack_public_path__ + "static/img/n-one.55e16d7c.webp";